// package
import { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Spinner, Image, Form } from "react-bootstrap";
import AmlHashForm from "aml-hash-form";
import moment from "moment";

// component
import AgDelete from "elements/System/AgDelete";
import AgStatus from "elements/System/AgStatus";
import { api, common } from "includes";

const Comments = (props: any) => {
  //const
  const authData: any = common.getAuth();
  // state
  const [process, setProcess] = useState<any>({ result: 100 });
  const [confirm, setConfirm] = useState<any>({ id: null, type: null });
  const [submit, setSubmit] = useState<any>("");
  const [resultList, setResultList] = useState<any>({ data: [], pageInfo: {} });
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [files, setFiles] = useState<File[]>([]);
  const [replyFiles, setReplyFiles] = useState<{ [key: string]: File[] }>({}); // per reply
  const [replyPages, setReplyPages] = useState<{ [key: string]: number }>({});
  const replyLimit = 10;
  const [sort, setSort] = useState<any>({
    field: "createdAt",
    order: "desc",
  });
  const [page, setPage] = useState<any>({
    limit: 10,
    page: 0,
    total: 0,
  });
  const [replyTo, setReplyTo] = useState<any>(null); // stores the comment being replied to
  const [replyComment, setReplyComment] = useState<string>(""); // local state for reply box
  const [expandedComments, setExpandedComments] = useState<{
    [key: string]: boolean;
  }>({});

  // form
  const formFields = {
    incidentId: { validate: [] },
    userId: { validate: [] },
    img: { validate: [] },
    comment: { validate: [] },
  };

  const {
    fields,
    errors,
    handleChange,
    handleSubmit,
    setMultiValue,
    handleReset,
  } = AmlHashForm(formFields);

  // // effect
  // useEffect(() => {
  //   if (props.incidentId) {
  //     getData();
  //   } else {
  //     processState("result", 200);
  //   }
  // }, []);

  const getVisibleReplies = (comment: any) => {
    const page = replyPages[comment._id] || 1;
    return comment.replies?.slice(0, page * replyLimit) || [];
  };

  const hasMoreReplies = (comment: any) => {
    const page = replyPages[comment._id] || 1;
    return comment.replies?.length > page * replyLimit;
  };

  // effect
  useEffect(() => {
    if (page.page > 0) {
      getNextComments();
    } else {
      getData();
    }
  }, [page.page, sort.order]);

  // api
  const getData = () => {
    processState("result", 100);
    let query = `?offset=${page.page + 1}&limit=${page.limit}&sortBy=${sort.field
      }&sortDir=${sort.order}`;
    let data: any = {
      url: `admin/incident/comment/${props.incidentId}`,
      method: "GET",
      query,
    };
    api.call(data, (res: any) => {
      processState("result", res.status);
      if (res.status === 200) {
        let result = res.data;
        setResultList(result);
        setPage((pData: any) => {
          let nData = common.reParse(pData);
          nData.limit = nData.limit;
          nData.page = nData.page;
          nData.total = result.pageInfo.totalCount;
          return nData;
        });
        setMultiValue({
          incidentId: props.incidentId,
          userId: authData?._id,
          img: [],
          comment: "",
        });
      }
    });
  };

  const getNextComments = () => {
    setPageLoader(true);
    let query = `?offset=${page.page + 1}&limit=${page.limit}&sortBy=${sort.field
      }&sortDir=${sort.order}`;
    let data: any = {
      url: `admin/incident/comment/${props.incidentId}`,
      method: "GET",
      query,
    };
    api.call(data, (res: any) => {
      if (res.status === 200) {
        let result = res.data;
        // Use functional update to ensure the latest state is used
        setResultList((prevResultList: any) => {
          return {
            ...prevResultList,
            data: [...(prevResultList.data || []), ...result.data],
          };
        });
        setPage((pData: any) => {
          let nData = common.reParse(pData);
          nData.limit = nData.limit;
          nData.page = nData.page;
          nData.total = result.pageInfo.totalCount;
          return nData;
        });
        setPageLoader(false);
      }
    });
  };

  // save
  const save = async (inputFile?: any, commentId?: string) => {
    let data = common.formPayload(fields, []);
    const isReply = !!commentId;
    data.comment = isReply ? replyComment : fields.comment;
    if (inputFile) {
      data.img = inputFile;
    }

    // Extract mentions from comment
    const mentionRegex = /@(\w+)/g;
    const matches = [...data.comment.matchAll(mentionRegex)];

    const mentionsArray = matches
      .map((m) => {
        // try to find user by firstName
        const user =
          resultList.data.find(
            (c: any) => c.userId.firstName.toLowerCase() === m[1].toLowerCase()
          ) ||
          resultList.data
            .flatMap((c: any) => c.replies || [])
            .find(
              (r: any) =>
                r.userId.firstName.toLowerCase() === m[1].toLowerCase()
            );

        return user
          ? {
              _id: user.userId._id,
              firstName: user.userId.firstName,
              lastName: user.userId.lastName,
              email: user.userId.email,
            }
          : null;
      })
      .filter(Boolean);

    data.mentions = mentionsArray;

    // handle reply parentId
    if (isReply) {
      const findParent = (comments: any[], replyId: string): any => {
        for (let c of comments) {
          if (c._id === replyId) return c;
          if (c.replies) {
            const found = findParent(c.replies, replyId);
            if (found) return c;
          }
        }
        return null;
      };
      const parentComment = findParent(resultList.data, replyTo);
      data.parentId = parentComment ? parentComment._id : replyTo;
    }

    // API Call 
    let param = {
      url: `admin/incident/comment/${props.incidentId}`,
      method: "POST",
      body: data,
    };

    api.call(param, (res: any) => {
      if (res.status === 200) {
        common.notify(
          "S",
          isReply ? "Reply added successfully" : "Comment added successfully"
        );

        // reset reply box
        if (isReply) {
          setReplyComment("");
          setReplyFiles((prev) => ({ ...prev, [commentId!]: [] }));
          setReplyTo(null);
        } else {
          setFiles([]);
          setMultiValue({
            incidentId: props.incidentId,
            userId: authData?._id,
            img: [],
            comment: "",
          });
          handleReset();
        }
        getData();
      } else {
        common.notify("E", res?.data.error || "Something went wrong!");
      }
      setSubmit("");
    });
  };

  // featured
  const setFeatured = (url: any) => {
    let data: any = { featuredImageUrl: url };

    let param = {
      url: `admin/incident/${props.incidentId}`,
      method: "PUT",
      body: data,
    };

    api.call(param, (res: any) => {
      if (res.status === 200) {
        props.refresh(true);
        common.notify("S", "Image set as Featured Successfully.");
      } else {
        common.notify("E", res?.data.error);
      }
    });
  };

  // delete
  const deleteComment = () => {
    let result = resultList.data?.filter((obj: any) => obj._id != confirm.id);
    setResultList((prevResultList: any) => {
      return {
        ...prevResultList,
        data: result,
      };
    });
    let data: any = {
      url: `admin/incident/comment/${props.incidentId}/${confirm.id}`,
      method: "DELETE",
    };

    api.call(data, (res: any) => {
      if (res.status === 200) {
        setConfirm({ id: null, type: "" });
        common.notify("S", "Comment deleted successfully");
        getData();
      } else {
        common.notify("E", res.error);
      }
    });
  };

  const isOnlyMentions = (text: string) => {
    // Remove all @mentions (e.g., "@John", "@mary123")
    const cleaned = text.replace(/@\w+/g, "").trim();
    return cleaned === "";
  };

  // events
  const onSubmit = async (e: any) => {
    e.preventDefault();
    const isValid = handleSubmit();
    const isReply = !!replyTo;

    const commentValue = isReply
      ? replyComment?.trim()
      : fields.comment?.trim();

    const currentFiles = isReply ? replyFiles[replyTo] || [] : files;

    // if (!commentValue && currentFiles.length === 0) {
    if (
      (!commentValue || isOnlyMentions(commentValue)) &&
      currentFiles.length === 0
    ) {
      common.notify("E", "Please add a comment or upload an image.");
      return;
    }
    if (isValid) {
      setSubmit("submit");
      let resFile: any = null;
      if (currentFiles.length > 0) {
        resFile = isReply
          ? await uploadReplyFiles(replyTo)
          : await uploadFile();
      }

      await save(resFile);
    }
  };

  // reply submit
  const onSubmitReply = async (e: any, commentId: string) => {
    e.preventDefault();

    const commentValue = replyComment?.trim();
    const currentFiles = replyFiles[commentId] || [];

    if (
      (!commentValue || isOnlyMentions(commentValue)) &&
      currentFiles.length === 0
    ) {
      common.notify("E", "Please add a reply or upload an image.");
      return;
    }

    setSubmit(commentId); 

    let resFile: any = null;
    if (currentFiles.length > 0) {
      resFile = await uploadReplyFiles(commentId);
    }

    await save(resFile, commentId); 
  };

  // delete
  const deleteCallBack = (isDelete: boolean) => {
    if (isDelete) {
      deleteComment();
    } else {
      setConfirm({ id: null, type: "" });
    }
  };

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const maxFileSize = 5 * 1024 * 1024; // 5 MB
  //   if (e.target.files) {
  //     const validFiles = Array.from(e.target.files).filter(file =>
  //       file.size <= maxFileSize && file.type.startsWith("image/")
  //     );
  //     setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  //   }
  // };

  // handleFileChange
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const maxFileSize = 2 * 1024 * 1024; // 5 MB in bytes

    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const oversizedFiles = newFiles.filter((file) => file.size > maxFileSize);

      if (oversizedFiles.length > 0) {
        // Show notification for oversized files
        common.notify(
          "E",
          `File size should not exceed 5 MB. Please upload smaller files.`
        );
        return;
      }

      // Add only files that are within the size limit
      const validFiles = newFiles.filter((file) => file.size <= maxFileSize);

      setFiles((prevFiles) => [...prevFiles, ...validFiles]);
    }
  };

  // HandleReplyFileChange
  const handleReplyFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    commentId: string
  ) => {
    const fileList = e.target.files;
    if (!fileList) return; // safeguard

    const maxFileSize = 5 * 1024 * 1024; // 5 MB in bytes
    const newFiles = Array.from(fileList);

    // Check for oversized files
    const oversizedFiles = newFiles.filter((file) => file.size > maxFileSize);
    if (oversizedFiles.length > 0) {
      common.notify(
        "E",
        `File size should not exceed 5 MB. Please upload smaller files.`
      );
      return;
    }

    const validFiles = newFiles.filter((file) => file.size <= maxFileSize);

    // Update files state for specific reply
    setReplyFiles((prev) => ({
      ...prev,
      [commentId]: [...(prev[commentId] || []), ...validFiles],
    }));
  };

  // Remove file
  const removeFile = (e: any, index: number) => {
    e.preventDefault();
    setFiles((prevFiles: any) =>
      prevFiles.filter((_: any, i: any) => i !== index)
    );
  };

  // Upload file
  const uploadFile = async () => {
    if (files) {
      const formData = new FormData();
      [...files].forEach((file) => {
        formData.append("file", file);
      });
      try {
        let data = {
          url: "common/upload",
          method: "POST",
          body: formData,
          ssr: true,
          cType: 6,
        };
        let response: any = await api.call(data, (res: any) => {});
        if (response.status === 200) {
          return response.data?.data?.url;
        } else return null;
      } catch (error) {
        common.notify("E", "File upload failed. Please try again.");
        return null;
      }
    }
  };

  // UploadReplyFiles file
  const uploadReplyFiles = async (commentId: string) => {
    const files = replyFiles[commentId];
    if (!files || files.length === 0) return null;

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file);
    });

    try {
      let data = {
        url: "common/upload",
        method: "POST",
        body: formData,
        ssr: true,
        cType: 6,
      };
      let response: any = await api.call(data, () => {});
      if (response.status === 200) {
        return response.data?.data?.url; // same format as uploadFile
      }
      return null;
    } catch (err) {
      common.notify("E", "File upload failed. Please try again.");
      return null;
    }
  };

  // callback
  const onAgCallBack = (status: any) => {
    getData();
  };

  // support
  const processState = (label: any, value: any) => {
    setProcess((prev: any) => ({
      ...prev,
      [label]: value,
    }));
  };
  const toggleReplies = (commentId: string) => {
    const isExpanded = !!expandedComments[commentId];

    if (!isExpanded) {
      // Expand
      setExpandedComments((prev) => ({ ...prev, [commentId]: true }));

      // Ensure page starts at 1
      setReplyPages((prev) => ({ ...prev, [commentId]: 1 }));
    } else {
      // Collapse
      setExpandedComments((prev) => ({ ...prev, [commentId]: false }));

      // Reset page count so next time it starts fresh
      setReplyPages((prev) => ({
        ...prev,
        [commentId]: 1,
      }));
    }
  };

  const formatMentions = (text: string) => {
    return text
      .replace(/@(\w+)/g, '<span class="text-primary fw-bold">@$1</span>')
      .replace(/\n/g, "<br/>"); // preserves new lines
  };

  // Render
  return (
    <Card>
      <Card.Body>
        {process.result != 200 ? (
          <AgStatus
            process={process.result}
            message={{
              100: "Loading... Please wait!",
              404: "Something went wrong! Please Refresh Again",
            }}
            button={{ 400: "Refresh", 404: "Refresh" }}
            size="l"
            onAgCallBack={onAgCallBack}
          />
        ) : (
          <Fragment>
            <div className="float-end mb-2">
              <select
                className="form-select form-select-sm"
                value={sort.order}
                onChange={(e: any) => {
                  setSort({
                    field: "createdAt",
                    order: e.target?.value,
                  });
                  setPage({
                    limit: 10,
                    page: 0,
                    total: 0,
                  });
                }}
              >
                <option value="desc">Recent</option>
                <option value="asc">Older</option>
              </select>
            </div>
            <h4 className="mb-4 mt-0 fs-16">
              Comments ({resultList?.pageInfo?.totalCount})
            </h4>

            {/* Comments */}
            <div className="clerfix"></div>
            {resultList?.data.map((obj: any, idx: number) => {
              const replies = obj.replies || [];
              return (
                <div className="fw-bb py-2 mb-2" key={idx}>
                  {/* <Card.Body> */}
                  <div className="d-flex align-items-start justify-content-between">
                    <div className="d-flex w-100">
                      {/* Avatar */}
                      {obj.userId?.img ? (
                        <Image
                          src={obj.userId?.img}
                          alt="post-img"
                          width={50}
                          height={50}
                          roundedCircle
                          className="me-2 flex-shrink-0"
                        />
                      ) : (
                        <span
                          className="d-flex align-items-center justify-content-center bg-secondary text-white rounded-circle me-2 flex-shrink-0"
                          style={{ width: 50, height: 50, fontSize: "1rem" }}
                        >
                          {obj.userId?.firstName
                            ? obj.userId.firstName.substring(0, 2).toUpperCase()
                            : "NA"}
                        </span>
                      )}

                      {/* Comment content */}
                      <div className="flex-grow-1">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <h5 className="my-1">
                              {obj.userId?.firstName} {obj.userId?.lastName}
                            </h5>
                            <small
                              className="text-muted d-block"
                              style={{ fontSize: "12px" }}
                            >
                              {moment(obj.createdAt).format(
                                "DD MMM YYYY hh:mm A"
                              )}
                            </small>
                          </div>
                          <Button
                            variant="danger"
                            size="sm"
                            className="ms-2 d-felx align-items-center"
                            onClick={() =>
                              setConfirm({ id: obj._id, type: "comment" })
                            }
                          >
                            <i className="ri-delete-bin-line fs-16" />
                          </Button>
                        </div>
                        {/* main comment */}
                        <p className="mb-2 mt-2 text-break text-prewrap">
                          {obj.comment}
                        </p>
                        {/* Comment Images */}
                        <div className="incidents-comment-desc">
                          {obj.img.map((url: any, idx: any) => {
                            return (
                              url && (
                                <Fragment>
                                  <Link to={url} target="_blank">
                                    <Image
                                      key={idx}
                                      src={url}
                                      alt="post-img"
                                      className="rounded me-1 mb-2"
                                      width="60"
                                      height="60"
                                    />
                                  </Link>
                                  {props?.featured && (
                                    <Button
                                      className="rounded me-1 mb-2"
                                      variant="success"
                                      onClick={() => setFeatured(url)}
                                    >
                                      Set Featured
                                    </Button>
                                  )}
                                </Fragment>
                              )
                            );
                          })}
                        </div>

                        {/* Reply + Expand/Collapse */}
                        <div className="mb-2 d-flex align-items-center">
                          <Button
                            variant="link"
                            size="sm"
                            className="p-0 d-flex align-items-center"
                            onClick={() => {
                              // Toggle replies open/close
                              toggleReplies(obj._id);

                              // If expanding, also open reply box
                              if (!expandedComments[obj._id]) {
                                setReplyTo(obj._id);
                                setReplyComment(`@${obj.userId?.firstName} `);
                              } else {
                                // If collapsing, close reply box
                                setReplyTo(null);
                                setReplyComment("");
                              }
                            }}
                          >
                            <i className="ri-reply-line" />
                            <span className="ms-1">
                              {replies.length > 0
                                ? `${replies.length} ${
                                    replies.length === 1 ? "Reply" : "Replies"
                                  }`
                                : "Reply"}
                            </span>
                          </Button>
                        </div>

                        {/* Inline Reply Box */}
                        {replyTo === obj._id && (
                          <div className="border rounded mt-3 p-2">
                            <form
                              className="comment-area-box"
                              onSubmit={(e) => onSubmitReply(e, obj._id)}
                              // onSubmit={(e) => onSubmit(e)}
                            >
                              {/* Highlight Layer
                                   <div
                                     className="highlight-layer"
                                     dangerouslySetInnerHTML={{
                                     __html: formatMentions(replyComment),
                              }}
                              /> */}

                              {/* reply textarea */}
                              <textarea
                                rows={2}
                                name="replyComment"
                                value={replyComment}
                                onChange={(e) => {
                                  setReplyComment(e.target.value);
                                }}
                                className="form-control border-0 resize-none"
                                placeholder={`Reply to ${obj.userId?.firstName}...`}
                              />

                              {/* </div> */}

                              <div className="p-2 bg-light d-flex justify-content-between align-items-center mt-1">
                                <div>
                                  <label
                                    className="btn btn-sm px-1 btn-light btn-mobile-sm"
                                    htmlFor={`file-reply-${obj._id}`}
                                  >
                                    <i className="ri-upload-line" />
                                    <Form.Control
                                      type="file"
                                      className="d-none"
                                      multiple={false}
                                      onChange={(e) =>
                                        handleReplyFileChange(
                                          e as React.ChangeEvent<HTMLInputElement>,
                                          obj._id
                                        )
                                      }
                                      accept="image/*"
                                      id={`file-reply-${obj._id}`}
                                    />
                                  </label>
                                </div>
                                <div className="d-flex gap-2">
                                  <Button
                                    variant="secondary"
                                    size="sm"
                                    className="btn-mobile-sm"
                                    onClick={() => setReplyTo(null)}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    type="submit"
                                    variant="primary"
                                    size="sm"
                                    className="btn-mobile-sm"
                                    // onClick={onSubmit}
                                    disabled={submit === obj._id}
                                  >
                                    {submit === obj._id ? (
                                      <>
                                        <Spinner
                                          className="spinner-border-sm me-1"
                                          color="white"
                                        />
                                        Processing...
                                      </>
                                    ) : (
                                      <>
                                        <i className="ri-save-line" /> Reply
                                      </>
                                    )}
                                  </Button>
                                </div>
                              </div>
                            </form>

                            {/* Reply uploaded files */}
                            {replyFiles[obj._id]?.length > 0 && (
                              <ul className="mt-2">
                                Uploaded Files:
                                {replyFiles[obj._id].map((file, index) => (
                                  <Fragment key={index}>
                                    <li>
                                      Name: {file.name}
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setReplyFiles((prev) => {
                                            const updated = [
                                              ...(prev[obj._id] || []),
                                            ];
                                            updated.splice(index, 1);
                                            return {
                                              ...prev,
                                              [obj._id]: updated,
                                            };
                                          });
                                        }}
                                      >
                                        <i className="ms-1 ri-delete-bin-6-line" />
                                      </Link>
                                    </li>
                                  </Fragment>
                                ))}
                              </ul>
                            )}
                          </div>
                        )}

                        {/* Nested Replies */}
                        {expandedComments[obj._id] && (
                          <>
                            {getVisibleReplies(obj).map((reply: any) => (
                              <div
                                key={reply._id}
                                className="d-flex flex-row align-items-start mt-3 mx-auto ms-0 ms-sm-5"
                              >
                                {/* Reply Avatar */}
                                {reply.userId?.img ? (
                                  <Image
                                    src={reply.userId.img}
                                    roundedCircle
                                    width={40}
                                    height={40}
                                    className="me-2 flex-shrink-0"
                                  />
                                ) : (
                                  <div
                                    className="me-2 d-flex justify-content-center align-items-center bg-secondary text-white rounded-circle flex-shrink-0"
                                    style={{
                                      width: 40,
                                      height: 40,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {reply.userId?.firstName
                                      ? reply.userId.firstName
                                          .substring(0, 2)
                                          .toUpperCase()
                                      : "NA"}
                                  </div>
                                )}

                                {/* Reply Content */}
                                <div className="flex-grow-1">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <strong>
                                      {reply.userId?.firstName}{" "}
                                      {reply.userId?.lastName}
                                    </strong>
                                    <Button
                                      variant="danger"
                                      size="sm"
                                      className="ms-2 p-0 px-1"
                                      style={{
                                        fontSize: "0.7rem",
                                        lineHeight: "1.1rem",
                                      }}
                                      onClick={() =>
                                        setConfirm({
                                          id: reply._id,
                                          type: "reply",
                                        })
                                      }
                                    >
                                      <i className="ri-delete-bin-line" />
                                    </Button>
                                  </div>
                                  <div
                                    className="text-muted mb-2"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {moment(reply.createdAt).format(
                                      "DD MMM YYYY hh:mm A"
                                    )}
                                  </div>
                                  <p className="mb-2 text-break text-prewrap">
                                    {reply.comment
                                      .split(" ")
                                      .map((word: string, idx: number) => {
                                        if (word.startsWith("@")) {
                                          return (
                                            <span
                                              key={idx}
                                              className="text-primary fw-bold"
                                            >
                                              {word}{" "}
                                            </span>
                                          );
                                        }
                                        return word + " ";
                                      })}
                                  </p>

                                  {/* Reply Images */}
                                  <div className="reply-comment-desc">
                                    {reply.img?.map((url: any, idx: any) => {
                                      return (
                                        url && (
                                          <Fragment key={idx}>
                                            <Link to={url} target="_blank">
                                              <Image
                                                src={url}
                                                alt="reply-img"
                                                className="rounded me-1 mb-1"
                                                width="60"
                                                height="60"
                                              />
                                            </Link>
                                            {props?.featured && (
                                              <Button
                                                className="rounded me-2 mb-1"
                                                variant="success"
                                                onClick={() => setFeatured(url)}
                                              >
                                                Set Featured
                                              </Button>
                                            )}
                                          </Fragment>
                                        )
                                      );
                                    })}
                                  </div>

                                  <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0"
                                    onClick={() => {
                                      setReplyTo(reply._id);
                                      setReplyComment(
                                        `@${reply.userId?.firstName} `
                                      );
                                      setMultiValue({
                                        replyComment: `@${reply.userId?.firstName} `,
                                      });
                                    }}
                                  >
                                    <i className="ri-reply-line" /> Reply
                                  </Button>

                                  {/* Inline child reply */}
                                  {replyTo === reply._id && (
                                    <div className="border rounded mt-2 p-2">
                                      <form
                                        className="comment-area-box"
                                        onSubmit={(e) =>
                                          onSubmitReply(e, reply._id)
                                        }
                                      >
                                        {/* Highlight Layer
                                            <div
                                              className="highlight-layer"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  formatMentions(replyComment),
                                              }}
                                            /> */}

                                        {/* Actual textarea */}
                                        <textarea
                                          rows={2}
                                          name="replyComment"
                                          value={replyComment}
                                          onChange={(e) => {
                                            setReplyComment(e.target.value);
                                          }}
                                          className="form-control border-0 resize-none position"
                                          placeholder={`Reply to ${obj.userId?.firstName}...`}
                                        />
                                        <div className="p-1 p-sm-2 bg-light d-flex justify-content-between align-items-center mt-1">
                                          <div>
                                            <label
                                              className="btn btn-sm px-1 btn-light btn-mobile-sm"
                                              htmlFor={`file-reply-${reply._id}`}
                                            >
                                              <i className="ri-upload-line" />
                                              <Form.Control
                                                type="file"
                                                className="d-none"
                                                multiple={false}
                                                onChange={(e) =>
                                                  handleReplyFileChange(
                                                    e as React.ChangeEvent<HTMLInputElement>,
                                                    reply._id
                                                  )
                                                }
                                                accept="image/*"
                                                id={`file-reply-${reply._id}`}
                                              />
                                            </label>
                                          </div>
                                          <div className="d-flex gap-2 reply-actions">
                                            <Button
                                              variant="secondary"
                                              size="sm"
                                              className="btn-mobile-sm"
                                              onClick={() => setReplyTo(null)}
                                            >
                                              Cancel
                                            </Button>
                                            <Button
                                              type="submit"
                                              variant="primary"
                                              size="sm"
                                              className="btn-mobile-sm"
                                              disabled={submit === reply._id}
                                            >
                                              {submit === reply._id ? (
                                                <>
                                                  <Spinner
                                                    className="spinner-border-sm me-1"
                                                    color="white"
                                                  />
                                                  Processing...
                                                </>
                                              ) : (
                                                <>
                                                  <i className="ri-save-line" />{" "}
                                                  Reply
                                                </>
                                              )}
                                            </Button>
                                          </div>
                                        </div>
                                      </form>

                                      {/* Nested Reply Uploaded Files */}
                                      {replyFiles[reply._id]?.length > 0 && (
                                        <ul className="mt-2">
                                          Uploaded Files:
                                          {replyFiles[reply._id].map(
                                            (file, index) => (
                                              <Fragment key={index}>
                                                <li>
                                                  Name: {file.name}
                                                  <Link
                                                    to="#"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      setReplyFiles((prev) => {
                                                        const updated = [
                                                          ...(prev[reply._id] ||
                                                            []),
                                                        ];
                                                        updated.splice(
                                                          index,
                                                          1
                                                        );
                                                        return {
                                                          ...prev,
                                                          [reply._id]: updated,
                                                        };
                                                      });
                                                    }}
                                                  >
                                                    <i className="ms-1 ri-delete-bin-6-line" />
                                                  </Link>
                                                </li>
                                              </Fragment>
                                            )
                                          )}
                                        </ul>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}

                            {/* nseted reply Load more */}
                            <div className="mt-2 d-flex justify-content-center">
                              {hasMoreReplies(obj) ? (
                                <Button
                                  variant="primary"
                                  size="sm"
                                  className="rounded-pill px-3 py-1"
                                  onClick={() =>
                                    setReplyPages((prev) => ({
                                      ...prev,
                                      [obj._id]: (prev[obj._id] || 1) + 1,
                                    }))
                                  }
                                >
                                  Load more
                                </Button>
                              ) : (
                                replyPages[obj._id] > 1 && (
                                  <Button
                                    variant="primary"
                                    size="sm"
                                    className="rounded-pill px-3 py-1"
                                    onClick={() =>
                                      setReplyPages((prev) => ({
                                        ...prev,
                                        [obj._id]: 1,
                                      }))
                                    }
                                  >
                                    Show less
                                  </Button>
                                )
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* </Card.Body> */}
                </div>
              );
            })}

            {/* Load More */}
            {pageLoader && <Spinner animation="border" size="sm" />}
            {(page.page + 1) * page.limit <
              resultList?.pageInfo?.totalCount && (
              <div className="text-center mt-2">
                <Button
                  variant="secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    setPage((pData: any) => {
                      let nData = common.reParse(pData);
                      nData.page = nData.page + 1;
                      return nData;
                    });
                  }}
                  disabled={pageLoader}
                >
                  Load more
                </Button>
              </div>
            )}

            {/* Main Comment */}
            <div className="border rounded mt-4 p-2">
              <form className="comment-area-box">
                <textarea
                  rows={3}
                  name="comment"
                  value={fields.comment}
                  onChange={handleChange}
                  className="form-control border-0 resize-none"
                  placeholder="Your comment..."
                />
                <div className="p-2 bg-light d-flex justify-content-between align-items-center mt-1">
                  <div>
                    <label
                      className="btn btn-sm px-1 btn-light"
                      htmlFor="file1"
                    >
                      <i className="ri-upload-line" />
                      <Form.Control
                        value={""}
                        type="file"
                        className="d-none"
                        multiple={false}
                        onChange={handleFileChange}
                        accept="image/*"
                        id="file1"
                      />
                    </label>
                  </div>
                  <Button
                    variant="primary"
                    onClick={onSubmit}
                    disabled={submit === "submit"}
                  >
                    {submit === "submit" ? (
                      <>
                        <Spinner
                          className="spinner-border-sm me-1"
                          color="white"
                        />
                        Processing...
                      </>
                    ) : (
                      <>
                        <i className="ri-save-line" /> Submit
                      </>
                    )}
                  </Button>
                </div>
              </form>
            </div>
            {errors.comment && (
              <p className="text-danger fs-6 mt-1 mb-1">{errors.comment}</p>
            )}
            {files && files.length > 0 && (
              <ul className="mt-2">
                Uploaded Files:
                {files.map((file, index) => (
                  <Fragment key={index}>
                    <li>
                      Name: {file.name}
                      <Link to="#" onClick={(e) => removeFile(e, index)}>
                        <i className="ms-1 ri-delete-bin-6-line" />
                      </Link>
                    </li>
                  </Fragment>
                ))}
              </ul>
            )}
          </Fragment>
        )}
        {/* Delete confirmation */}
        {confirm.id && (
          <AgDelete type="delete" onAgDeleteCallBack={deleteCallBack} />
        )}
      </Card.Body>
    </Card>
  );
};
export default Comments;
